/* ==========================================================================
   Menu Category Nav
   Runs once regardless of how many "Menu category" section instances are
   on the page. Builds a shared sticky pill nav, wires up smooth scroll,
   and highlights the active category on scroll.
   ========================================================================== */

(function () {
  if (window.__menuCategoryNavInit) return;
  window.__menuCategoryNavInit = true;

  function init() {
    var categories = Array.prototype.slice.call(
      document.querySelectorAll('[data-menu-category]')
    );

    if (categories.length < 2) return; // nav only useful with 2+ categories

    var nav = document.createElement('nav');
    nav.className = 'menu-nav';
    nav.setAttribute('aria-label', 'Menu categories');
    var inner = document.createElement('div');
    inner.className = 'menu-nav__inner';
    nav.appendChild(inner);

    var pills = [];

    categories.forEach(function (section) {
      var title = section.getAttribute('data-nav-title') || '';
      var icon = section.getAttribute('data-nav-icon') || '';
      var id = section.id;

      var pill = document.createElement('a');
      pill.className = 'menu-nav__pill';
      pill.href = '#' + id;
      pill.dataset.target = id;
      pill.innerHTML =
        (icon ? '<span aria-hidden="true">' + icon + '</span>' : '') + title;

      pill.addEventListener('click', function (e) {
        e.preventDefault();
        var offset = nav.offsetHeight + 16;
        var top =
          section.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
      });

      inner.appendChild(pill);
      pills.push(pill);
    });

    categories[0].parentNode.insertBefore(nav, categories[0]);

    // Match scroll-margin-top to actual nav height so anchor jumps land correctly.
    var scrollOffset = nav.offsetHeight + 16;
    categories.forEach(function (section) {
      section.style.scrollMarginTop = scrollOffset + 'px';
    });

    // Scrollspy: highlight the pill for whichever category is in view.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var pill = pills.find(function (p) {
            return p.dataset.target === entry.target.id;
          });
          if (!pill) return;
          if (entry.isIntersecting) {
            pills.forEach(function (p) {
              p.classList.remove('is-active');
            });
            pill.classList.add('is-active');
          }
        });
      },
      {
        rootMargin: '-' + (scrollOffset + 10) + 'px 0px -70% 0px',
        threshold: 0,
      }
    );

    categories.forEach(function (section) {
      observer.observe(section);
    });

    // Default to first pill active on load.
    if (pills.length) pills[0].classList.add('is-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();